import type { ReactElement } from 'react'
import { AppShell } from '../components/AppShell.js'
import { Button } from '../components/ui/button.js'
import { Icon } from '../components/installer/icons.js'
import { HIGHLOOP_FAIL, PROOF_STEPS } from '../lib/proofSteps.js'
import { useDemoStore } from '../state/store.js'
import { useStep } from '../state/useStep.js'

/**
 * Bad-path verification result for the high-loop step. Reached only on the first
 * `highloop` capture attempt; the "Recapture high loop" CTA routes back to the
 * camera, where the retake passes.
 *
 * Ported from the Lovable prototype `Index.tsx` `screen-failed` (lines 598-641).
 */
export const VerifyFailedScreen = (): ReactElement => {
  const { state } = useDemoStore()
  const { goto } = useStep()

  const progress = (30 + ((state.activeIdx + 1) / PROOF_STEPS.length) * 60) / 100

  const footer = (
    <Button size="xl" onClick={() => goto('capture')}>
      <Icon.Camera /> Recapture high loop
    </Button>
  )

  return (
    <AppShell
      title="Verification failed"
      showBack
      onBack={() => goto('capture')}
      progress={progress}
      footer={footer}
    >
      <div className="installer-surface page fade-in">
        <div className="verify-image-card">
          <div
            className="verify-image"
            style={{ backgroundImage: `url(${HIGHLOOP_FAIL.photo})` }}
          >
            <div
              className="detection-box-fail"
              style={{
                top: HIGHLOOP_FAIL.cameraBox.top,
                left: HIGHLOOP_FAIL.cameraBox.left,
                width: HIGHLOOP_FAIL.cameraBox.width,
                height: HIGHLOOP_FAIL.cameraBox.height,
              }}
            >
              <div className="detection-label-fail">{HIGHLOOP_FAIL.cameraBox.text}</div>
            </div>
          </div>
        </div>

        <div className="signal-chip fail">
          <div className="signal-dot" />
          Defect found
        </div>

        <div className="outcome-card fail">
          <div className="outcome-title">{HIGHLOOP_FAIL.outcomeTitle}</div>
          <div className="outcome-body">{HIGHLOOP_FAIL.outcomeBody}</div>
        </div>
      </div>
    </AppShell>
  )
}
